import { createFileRoute } from '@tanstack/react-router';
import { CalendarsSettingsPage } from '../features/settings/CalendarsSettingsPage';

export const Route = createFileRoute('/settings/calendars')({
  component: CalendarsSettingsPage,
});
